import { render } from "./ConfirmarCodigo.vue?vue&type=template&id=13634012"
import script from "./ConfirmarCodigo.vue?vue&type=script&lang=js"
export * from "./ConfirmarCodigo.vue?vue&type=script&lang=js"

import "./ConfirmarCodigo.vue?vue&type=style&index=0&id=13634012&lang=css"

import exportComponent from "/home/thales/Projetos/termos-telemidia/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__